<app-loading [isLoading]="isLoading()" message="Loading Roadmap" [overlayOpacity]="0"></app-loading>

<div class="pdf-hide">
  <div class="d-flex">
    <div class="me-auto p-2">
      <button matButton class="primary" (click)="onExportToExcelClick()">
        <fa-icon [icon]="faFileExcel"></fa-icon> XLS
      </button>
      <button matButton class="primary" (click)="this.pdfAction.emit('download');">
        <fa-icon [icon]="faFilePdf"></fa-icon> PDF
      </button>
      <button matButton class="primary" (click)="this.pdfAction.emit('print');">
        <fa-icon [icon]="faPrint"></fa-icon> Print
      </button>
    </div>
    <div class="ms-auto p-2">
      <button matButton class="primary" (click)="onShowLegendPromptClick()">
       <fa-icon [icon]="faInfoCircle"></fa-icon> Show Roadmap Legend
      </button>
    </div>
  </div>
</div>

@for (category of roadmap()?.targetCategories; track category.id) {
  <table class="sctable">
    <thead>
      <tr>
        <th>
          <h3>{{category.name}}</h3>
        </th>
        <th class="min" style="text-align:center;">
          Recurring
        </th>
        <th class="min" style="text-align:center;">
          Plan
        </th>
        <th class="min">
          Leader (Who)
        </th>
        <th class="min">
          Target Date (When)
        </th>
        <th class="min">
          Status
        </th>
        <th class="min" style="text-align:center;">
          Comments
        </th>
        <th class="min" style="text-align:center;">
          Attachments
        </th>
      </tr>
    </thead>

    <tbody class="export-pdf-color">
      @for (condition of category.targetConditions; track condition.id) {
        <tr class="row-bottom"
          [class.goal-needsreview]="condition.roadmapTargets?.[0]?.isExpired"
          [class.goal-achieved]="condition.roadmapTargets?.[0]?.currentCondition?.id === 1"
          [class.goal-na]="condition.roadmapTargets?.[0]?.currentCondition?.id === 2"
          [class.goal-notachieved]="condition.roadmapTargets?.[0]?.currentCondition?.id === 3"
          [class.goal-isplanned]="condition.roadmapTargets?.[0]?.currentCondition?.id === 4"
        >
          <td>
            <mat-checkbox [disabled]="!isEditable()" class="align-self-center" class="primary" (change)="plannedGoalCheck($event, condition.roadmapTargets?.[0]!)" [(ngModel)]="condition.roadmapTargets?.[0]!.isPlannedGoal">
              <div class="d-flex flex-row">
                <div class="p-2 d-flex flex-column align-self-center">
                  <span>{{condition.name}}</span>
                  @if (condition.roadmapTargets?.[0]?.isExpired) {
                    <mat-icon class="align-self-center" style="color:red; font-size:16px"
                      matTooltip="ATTN: Recurring Date Past Due.  Goals needs to be re-reviewed and resubmitted."
                      matTooltipPosition="right" matTooltipShowDelay="150">flag
                    </mat-icon>
                  }
                  @if (goalIsRequired(condition)) {
                    <span class="align-self-center" style="color:red; font-size:36px; padding-top: 7px"
                      matTooltip="This goal is required because the volume is greater than $10M."
                      matTooltipPosition="right" matTooltipShowDelay="150">*
                    </span>
                  }
                </div>
                <div class="p-2" style="max-width: 450px;">
                  <span [innerHTML]="condition.description"></span>
                </div>
              </div>
            </mat-checkbox>
          </td>
          <td align="center">
            <div class="div-container-recurring">
              @if (condition.isRecurring) {
                <mat-icon [class.inactive]="condition.roadmapTargets?.[0]?.isPlannedGoal || !isEditable()"
                  matTooltip="{{infoGoalRecurring}}" matTooltipPosition="right" matTooltipShowDelay="150">calendar_month</mat-icon>
              } @else {
                <mat-icon [class.inactive]="condition.roadmapTargets?.[0]?.isPlannedGoal || !isEditable()"
                  matTooltip="{{infoGoalNotRecurring}}" matTooltipPosition="right" matTooltipShowDelay="150">calendar_today</mat-icon>
              }
              @if (condition.isRecurring) {
                <div class="mobile-col-hidden">{{infoGoalRecurringShort}}</div>
              } @else {
                <div class="mobile-col-hidden">{{infoGoalNotRecurring}}</div>
              }
            </div>
            <!-- Pdf Export Display -->
            <div class="pdf-show">
              <table class="pdf-secondrow-datatable">
                <tr>
                  <td>
                    @switch (condition.roadmapTargets?.[0]?.currentCondition?.id) {
                      @case(0) {
                        Not Planned
                      }
                      @case(4) {
                        Planned Goal
                      }
                      @case(1) {
                        Goal Achieved
                      }
                      @case(2) {
                        In Progress
                      }
                      @case(3) {
                        Not Achieved
                      }
                    }
                  </td>
                  <td align="center">
                    @if (condition.roadmapTargets?.[0]?.leaderName) {
                      Leader: None.
                    } @else {
                      Leader: {{condition.roadmapTargets?.[0]?.leaderName}}
                    }
                  </td>
                  <td>
                    @if (condition.roadmapTargets?.[0]?.achievementTargetDate == null) {
                      Target Date: None.
                    } @else {
                      Target Date: {{condition.roadmapTargets?.[0]?.achievementTargetDate}}
                    }
                  </td>
                </tr>
              </table>
            </div>
          </td>
          <td>
            <div class="div-container-goalplan">
              <div>
                @if (!condition.roadmapTargets?.[0]?.isPlannedGoal) {
                  <mat-icon class="inactive pdfexport-extra-pr"
                    matTooltip="This shows an implementation plan for a planned goal."
                    matTooltipPosition="below" matTooltipShowDelay="150">chat_bubble_outline</mat-icon>
                  <div class="mobile-col-hidden">Plan to achieve goal?</div>
                } @else {
                  @if (!condition.roadmapTargets?.[0]?.goalPlan) {
                    <mat-icon class="goal-plan-empty pdfexport-extra-pr"
                        matTooltip="No implementation plan has been made for this goal.  Click to set one."
                        matTooltipPosition="below" matTooltipShowDelay="150"
                        (click)="onOpenRoadmapGoalPlanClick(category, condition)">chat_bubble_outline</mat-icon>
                    <div class="mobile-col-hidden">No plan set for goal.</div>
                  } @else {
                    <mat-icon class="goal-plan-content pdfexport-extra-pr"
                        matTooltip="Goal has an implementation plan.  Click to view."
                        matTooltipPosition="below" matTooltipShowDelay="150"
                        (click)="onOpenRoadmapGoalPlanClick(category, condition)">sms</mat-icon>
                    <div class="mobile-col-hidden">Goal has a plan.</div>
                  }
                }
              </div>
            </div>
          </td>
          <td>
            <div class="div-container-leader compact-form-fields">
              <mat-form-field appearance="outline">
                <input matInput [disabled]="!condition.roadmapTargets?.[0]?.isPlannedGoal || !isEditable()" maxlength="100"
                 autocomplete="off" placeholder="Who is leading this goal?" [required]="leaderIsRequired(condition)" />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="div-container-targetdate compact-form-fields">
              <mat-form-field appearance="outline">
                <input matInput [disabled]="!condition.roadmapTargets?.[0]?.isPlannedGoal || !isEditable()"
                    [matDatepicker]="picker" placeholder="When will the goal be achieved?"  matTooltip="When will the goal be achieved?"
                    matTooltipPosition="right" matTooltipShowDelay="150">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="div-container-goalstatus compact-form-fields">
              <mat-form-field appearance="outline">
                @if (condition.roadmapTargets && condition.roadmapTargets[0]) {
                  <mat-select [disabled]="!condition.roadmapTargets[0].isPlannedGoal || !isEditable()" (selectionChange)="onStatusChanged($event, condition.roadmapTargets[0])" [(ngModel)]="condition.roadmapTargets[0].currentConditionId" placeholder="Select Status" matTooltip="Select the current status of this goal." matTooltipPosition="right" matTooltipShowDelay="150">
                    @for(currentCondition of currentConditions(); track currentCondition.id) {
                      <mat-option [value]="currentCondition.id" matTooltip="{{currentCondition.condition}}" matTooltipPosition="left" matTooltipShowDelay="150">{{currentCondition.shortName}}</mat-option>
                    }
                  </mat-select>
                }
              </mat-form-field>
            </div>
          </td>
          <td align="center">
            <div class="div-container-comment">
              @if (!conditionVersionHasComments(condition) && condition.roadmapTargets?.[0]?.roadmapComments?.length! > 0) {
                <span style="font-size:23px;" [matBadge]="condition.roadmapTargets?.[0]?.roadmapComments?.length!" matBadgeOverlap="true" matBadgeSize="large" matTooltip="{{infoNoComment}}"  matTooltipPosition="below" matTooltipShowDelay="150">
                  <fa-icon [icon]="faComments" style="font-size:23px;cursor:pointer" (click)="onRoadmapCommentClick(condition)"></fa-icon>
                </span>
              }
              @if (!conditionVersionHasComments(condition) && condition.roadmapTargets?.[0]?.roadmapComments?.length! < 1) {
                <fa-icon [icon]="faComments" style="font-size:23px;cursor:pointer" matTooltip="{{infoNoComment}}"
                  matTooltipPosition="below" matTooltipShowDelay="150"
                  (click)="onRoadmapCommentClick(condition)">
                </fa-icon>
              }
              @if (conditionVersionHasComments(condition)) {
                <span style="font-size:23px;" [matBadge]="condition.roadmapTargets?.[0]?.roadmapComments?.length!" matBadgeOverlap="true" matBadgeSize="large" matTooltip="{{getLastestFullComment(condition)}}"  matTooltipPosition="below" matTooltipShowDelay="150">
                  <fa-icon [icon]="faComments" [class]="{
                      'comment-latest-pt' : getLatestCommentType(condition) == 'pt',
                      'comment-latest-ra' : getLatestCommentType(condition) == 'ra',
                      'comment-latest-admin' : getLatestCommentType(condition) == 'admin',
                      'comment-latest-pca' : getLatestCommentType(condition) == 'pca',
                      'comment-latest' : getLatestCommentType(condition) != null
                    }"
                    (click)="onRoadmapCommentClick(condition)">
                  </fa-icon>
                </span>
              }
              @if (!conditionVersionHasComments(condition)) {
                <div class="mobile-col-hidden">{{infoNoComment}}</div>
              } @else {
                <div class="mobile-col-hidden">{{getLastestFullComment(condition)}}</div>
              }
            </div>
          </td>
          <td align="center">
            @if(getAttachmentsCount(condition) > 0) {
              <span style="font-size:23px;" [matBadge]="getAttachmentsCount(condition)" matBadgeOverlap="true" matBadgeSize="large">
                <fa-icon [icon]="faFolder" style="font-size:23px;cursor:pointer"
                  matTooltip="Manage for this goal."
                  matTooltipPosition="below" matTooltipShowDelay="150"
                  (click)="onRoadmapAttachmentsClick(condition)"></fa-icon>
              </span>
            } @else {
              <fa-icon [icon]="faFolder" style="font-size:23px;cursor:pointer"
                  matTooltip="Manage attachments for this goal."
                  matTooltipPosition="below" matTooltipShowDelay="150"
                  (click)="onRoadmapAttachmentsClick(condition)"></fa-icon>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
